import { db } from "../../index";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../App";
import {createCustomer, updateCustomer, useCustomerOptions} from "../customer";
import { startLoading, stopLoading } from "../loader";

export async function createProvider(userInfos, provider) {
  startLoading();

  let snap = await db.ref(`users/${userInfos.uid}/provider`).push(provider);
  let providerId = snap.key;

  await db
    .ref(`users/${userInfos.uid}/provider/${providerId}`)
    .update({ id: snap.key });
  provider.id = providerId;

  if (provider.isIndividual) {

    let customer = await createCustomer(userInfos, {
      firstname: provider.firstname,
      lastname: provider.lastname,
      email: provider.email,
      phone: provider.tel,
      provider: provider,
    });

    let _customer = {...customer, provider: null};

    await db
      .ref(`users/${userInfos.uid}/provider/${providerId}`)
      .update({ customer: _customer });
    provider.customer = _customer;
  }

  stopLoading();

  return provider;
}

export async function updateProvider(userInfos, provider) {
  startLoading();

  await db
    .ref(`users/${userInfos.uid}/provider/${provider.id}`)
    .update(provider);

  if (provider.isIndividual) {
    let _provider = {...provider, customer: null};

    let customer = await updateCustomer(userInfos, {
      firstname: provider.firstname,
      lastname: provider.lastname,
      email: provider.email,
      phone: provider.tel,
      provider: _provider,
      id: provider.customer.id
    });

    let _customer = {...customer, provider: null};
    await db
      .ref(`users/${userInfos.uid}/provider/${provider.id}`)
      .update({ customer: _customer });
  }

  stopLoading();
}

export async function deleteProvider(userInfos, provider_id) {
  if (!Array.isArray(provider_id)) {
    provider_id = [provider_id];
  }

  startLoading();

  let pList = provider_id.map(async (id) => {
    if (id) await db.ref(`users/${userInfos.uid}/provider/${id}`).remove();
  });

  await Promise.all(pList);

  stopLoading();
}

export function useProviders() {
  const { userInfos } = useContext(UserContext);
  const [providers, setProviders] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    db.ref("users/" + userInfos.uid + "/provider")
      .once("value")
      .then((snapshot) => {
        let res = [];
        snapshot.forEach(function (childSnapshot) {
          res.push({
            id: childSnapshot.key,
            ...childSnapshot.val(),
          });
        });
        setProviders(res);
        setLoaded(true);
      });
  }, [userInfos.uid]);

  return { providers, loaded };
}

export function useCustomersAndProvidersOptions() {
  const { providers } = useProviders();
  const customerOptions = useCustomerOptions();
  const [results, setResults] = useState([]);

  useEffect(() => {
    let res = [];

    for (let provider of providers) {
      res.push({
        label: "[Client] " + provider.name,
        data: {
          id: provider.id,
          firstname: provider.name,
          lastname: "",
          email: provider.email,
          phone: provider.tel,
          provider: provider,
          contacts: provider.contacts,
          isProvider: true,
        },
      });
    }

    res.push(...customerOptions);
    console.log("customers: ", customerOptions);

    setResults(res);
  }, [customerOptions, providers]);

  return results;
}
